/* Component Dependencies */
var guestRoomTemplate = require('templates/guestRoom.hbs');
var guestRoomRoomsTemplate = require('templates/guestRoom-rooms.hbs');
var guestRoomLiteTemplate = require('templates/guestRoom-lite.hbs');
var AriesComponent = require('libs/aries-component');
var Popup = require('libs/popup');
var $ = require('jquery');
var LoadingIndicator = require('utils/loading-indicator');

AriesComponent.create({
  type: 'guestRoom',
  template: {
    'guestRoom': guestRoomTemplate,
    'guestRoom-rooms': guestRoomRoomsTemplate,
    'guestRoom-lite': guestRoomLiteTemplate
  },
  bindEvents: function() {
    var checkRatesLink = this.$el.find('li');
    var _self = this,
      $this;

    _self.isAllItemShowed = false;
    _self.elm = $('html');
    _self.$el.find('.mi-popover').each(function() {
      $this = $(this);
      $this.data('ratePopup', new Popup({
        selector: $this,
        sourceBlock: '.modal-content',
        alternateCloseMarkup: true,
        mainClass: 'mi-gallery modal-guest-room-images guest-room-popup-wrapper',
        showPrintButton: true,
        contentLoaded: _self.adjustScroll
      }));
      $this.data('ratePopup').register();
      $this.on('mfpOpen', _self.onModalOpen.bind(_self));
      $this.on('mfpClose', _self.onModalClose.bind(_self));
    });

    this.setContainerWidth(checkRatesLink.length);
    $(window).on('resize', this.setContainerWidth.bind(this, checkRatesLink.length));

    $(window).on('load resize', function() {
      if ($(window).width() > 768) {
        _self.$el.find('.t-font-mll').addClass('t-font-l');
      } else {
        _self.$el.find('.t-font-mll').removeClass('t-font-l');
      }
    });
    
    this.handleImageClick();
    _self.$el.find('.l-toggle-list').on('click', _self.toggleListDetails.bind(_self));
  },
 
  /*
   * Changes to remove extra scroll in guest room popup.
   */
  adjustScroll: function() {
    this.$el.closest(".mfp-wrap").attr("style", "overflow-x: hidden;overflow-y: scroll;-webkit-overflow-scrolling:touch")
  },
  /**
   * This function is used to add class on html
   * for double scrollbar Fix
   */
  onModalOpen: function() {
    this.elm.addClass('hws-scroll-hidden');
  },
  /**
   * This function is used to remove class on html
   * for double scrollbar Fix
   */
  onModalClose: function() {
      this.elm.removeClass('hws-scroll-hidden');
  },
  /**
   * This function is used to set the width of the image container
   * @param {Number} numberOfImages : Number of Images 1, 2 or 3
   */
  setContainerWidth: function(numberOfImages) {
    if (this.$el.hasClass("tile-guest-room")) {
      this.$el.find('ul').css('width', ((numberOfImages * this.$el.find('li').width()) + ((numberOfImages - 1) * 20)));
      if (numberOfImages === 3 && window.innerWidth < 1024) {
        this.$el.find('ul').css('width', "");
      }
    }
  },
  /**
   * This function is used to trigger the check rates button click, on click of the respective image
   */
  handleImageClick: function() {
    var roomList;
    roomList = this.$el.find('li');
    roomList.each(function() {
      if($(this).find('.js-img-click').length == 0){
        $(this).find('img, .l-photoComingSoon-text').click(function() {
          $(this).closest('li').find('a')[0].click();
        })
      }
    });
  },
  /**
   * This method is used to toggle the details view of the guest room on lite site
   * and Change the corresponding details label
   */
  toggleListDetails: function _toggleListDetails(e) {
    var _self = this,
    roomCardList,
    guestRoomCardsList = "",
    renderHotelList = "",
    callAjax = "";
    var jsonData = {};
    $guestRoomCardContainer = _self.$el.find('ul');
    var loader = new LoadingIndicator($guestRoomCardContainer); 
    if(!$guestRoomCardContainer.hasClass('ajaxCompleted')){
      loader.addLoader();
      jsonData = _self.getContextData();
      jsonData.context = _self.getExtendedComponentContext();
      jsonData.context.roomPoolCount="All";
      e.preventDefault();
        _self.makeAjaxCall({
          url:_self.$el.data('component-endpoint'),
          method: 'POST',
          data: JSON.stringify(jsonData),
          success : function(data){
            var response = data.component.data;
            roomCardList = response.roomList;
            roomCardList.forEach( function(list, index) {
              if ( index > 2 ){
                guestRoomCardsList += '<li class="l-guestRoom-info b-cardBackgroundColor l-border-box-sizing l-guest-room-box-shadow l-s-col-4 l-m-col-4 l-l-col-4 l-padding-none l-pos-relative l-guestroom-padding-bottom l-margin-subsection-bottom-medium l-panel-show l-panel-mobile l-panel-tablet l-panel-Desktop">';
                if(list.roomImageList.length == 0 ){
                  guestRoomCardsList +='<div class="l-pos-relative"><picture class="l-picture-wrapper l-display-block l-max-height"><source srcset="'+response.baseUrl+''+response.photoComingSoonClassicImage+'?interpolation=progressive-bilinear&downsize=378px:*" media="(min-width: 600px)"><source srcset="'+response.baseUrl+''+response.photoComingSoonClassicImage+'?interpolation=progressive-bilinear&downsize=378px:* " media="(max-width: 600px)"><img src="'+response.baseUrl+''+response.photoComingSoonClassicImage+'?interpolation=progressive-bilinear&downsize=378px:*" class="l-align-center l-width-max" alt="'+response.photoComingSoonLabel+'"></picture><div class="l-pos-absolute l-photoComingSoon-text">'+response.photoComingSoonLabel+'</div></div>';
                } else {
                  guestRoomCardsList +='<picture class="l-picture-wrapper l-display-block l-max-height"><source srcset="'+response.baseUrl+''+list.roomImageList[0].fullImageFile+'?interpolation=progressive-bilinear&downsize=378px:*" media="(min-width: 600px)"><source srcset="'+response.baseUrl+''+list.roomImageList[0].fullImageFile+'?interpolation=progressive-bilinear&downsize=378px:*" media="(min-width: 600px)"><img src="'+response.baseUrl+''+list.roomImageList[0].fullImageFile+'?interpolation=progressive-bilinear&downsize=378px:*" class="l-align-center l-width-max" alt=""></picture>';
                }  
                guestRoomCardsList += '<div class="t-room-info l-s-col-4 l-margin-top-quarter"><div class="l-margin-left l-margin-right"><h3 class="t-font-size-name l-margin-bottom-half">'+list.roomTypeName+'</h3><span class="t-font-m l-display-inline-block t-color-standard-90">'+list.roomDetails+'</span></div></div><div class="l-margin-left l-margin-right l-margin-subsection-bottom-medium l-pos-absolute l-pos-bottom"><a href= "#'+response.roomPoolCodeLabel+'='+list.roomPoolCode+'" class="mi-popover m-button t-font-m m-button-primary l-padding-top-three-quarters l-padding-bottom-three-quarters l-display-inline-block">'+response.checkRatesLabel+'</a></div></li>';
              }
            });
            renderHotelList += guestRoomCardsList;
            $guestRoomCardContainer.append(renderHotelList);
            loader.removeLoader();
          }, 
        });
    }
    if(!$guestRoomCardContainer.hasClass('ajaxCompleted')){
      $guestRoomCardContainer.addClass('ajaxCompleted');
    }
    $toggleButton = _self.$el.find('.l-toggle-list');
    _self.$el.find('li').toggleClass('hidden l-panel-show');
    !_self.isAllItemShowed ? $(e.target).text($toggleButton.data('label-collapse')) : $(e.target).text($toggleButton.data('label-expand'));
    _self.isAllItemShowed = !_self.isAllItemShowed;
  }
});